<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'DownTriangle'
};
</script>

<style lang="stylus" scoped>
.icon_wrap
  display inline-block
  width 16px
  height 16px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/h5_payment_icon_open.png')
  background-image image-set(url('./images/h5_payment_icon_open.png') 1x, url('./images/h5_payment_icon_open@2x.png') 2x)
</style>
